"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledHR = _styledComponents.default.hr.attrs({
  "data-qa": "styled-hr"
}).withConfig({
  displayName: "MenuLine__StyledHR",
  componentId: "sc-5ej6qg-0"
})(["border:1px solid ", ";border-bottom:0;margin:0;"], function (props) {
  return props.theme.carvana.gray.light;
});

var MenuLine = function MenuLine(_ref) {
  var className = _ref.className;
  return _react.default.createElement(StyledHR, {
    className: className,
    "data-qa": "menu-line"
  });
};

MenuLine.defaultProps = {
  className: ''
};
var _default = MenuLine;
exports.default = _default;
module.exports = exports.default;